import { createFileRoute } from '@tanstack/react-router';
import { AuthShell } from '@/components/templates/AuthShell';
import { Button } from '@/components/atoms/Button';

export const Route = createFileRoute('/reset')({ component: ResetPage });

function ResetPage() {
  return (
    <AuthShell>
      <h1 className="font-display text-title text-foreground">Reset password</h1>
      <p className="mt-1 text-body-sm text-muted-foreground">
        Password resets happen on the Auth0 hosted login page. From there, choose
        &quot;Don&apos;t remember your password?&quot;
      </p>
      <Button variant="tertiary" fullWidth className="mt-6" asChild>
        <a href="/login">Back to sign in</a>
      </Button>
    </AuthShell>
  );
}
